import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const RejectOfferModal = ({ show, onHide, offer, onSubmit }) => {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    if (!reason.trim()) {
      alert("Please enter a reason for rejection.");
      return;
    }

    onSubmit({ offerId: offer?.id, reason });
    setReason(""); // clear on submit
  };

  const handleClose = () => {
    setReason(""); // reset on close
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Reject Offer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to reject the offer for{" "}
          <strong>{offer?.product?.name}</strong>?
        </p>
        <Form.Group>
          <Form.Label>Rejection Reason</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter reason for rejecting this offer"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Reject Offer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectOfferModal;
